import BaseApi from "../baseApi";

interface ICacheApi {
    ClearProduct: (
        itemNumber: string,
    ) => Promise<void>;
    ClearNavCache: () => Promise<void>;
}

export default class CacheApi extends BaseApi implements ICacheApi {
    async ClearProduct(
        itemNumber: string,
    ): Promise<void> {
        const url = `/api/cache/clear/product/${itemNumber}`;
        return await this.fetchGet(url);
    }

    async ClearNavCache(): Promise<void> {
        const url = `/api/cache/clear/nav`;
        return await this.fetchGet(url);
    }
}
